export default __webpack_public_path__ + "static/media/linxe.54862a48.png";